<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t(title)}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <error-msg-component :messages="error.messages"
                             :error="error.haveError"
                             :title="'mail.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error.haveError = $event"/>
        <div class="columns is-marginless">
          <div class="column is-9">
            <b-field
              :message="isArchivedContactSelected ?
                $t('detailContact.warning.archivedContacts') : ''"
              :type="isArchivedContactSelected ? 'is-warning' : ''">
            </b-field>
            <div class="columns is-multiline">
              <p class="label column is-2 pdb-0 mgt-5px">
                {{ $t('mail.envoyerA') }}</p>
              <qd-taginput class="input-contact column is-10 pdb-0"
                          autocomplete
                          allow-new
                          :data="toListContactTags"
                          group-field="nomCommercial"
                          group-options="contacts"
                          open-on-focus
                          field="nomToDisplay"
                          type="is-primary"
                          @typing="getFilteredToListContact"
                          @input="getToListContactTag"
                          @add="$emit('addContact', $event)"
                          @remove="$emit('removeContact', to)"
                          expanded
                          ref="tagsRefTo"
                          v-model="to">
                <template #selected="{ tags }">
                  <b-tag
                    v-for="(tag, index) in tags" :key="index"
                    @close="$refs.tagsRefTo.removeTag(index, $event)"
                    :type="!tag.archive ? 'is-primary' : 'is-warning'"
                    closable>
                    {{getNameTag(tag)}}
                  </b-tag>
                </template>
              </qd-taginput>
              <p class="label column is-2 pdb-0 mgt-5px">
                {{ $t('mail.cc') }}</p>
              <qd-taginput class="input-contact column is-10 pdb-0"
                          autocomplete
                          allow-new
                          :data="ccListContactTags"
                          group-field="nomCommercial"
                          group-options="contacts"
                          open-on-focus
                          field="nomToDisplay"
                          type="is-primary"
                          @typing="getFilteredCcListContact"
                          @input="getCcListContactTag"
                          expanded
                          ref="tagsRefCc"
                          v-model="cc">
                <template #selected="{ tags }">
                  <b-tag
                    v-for="(tag, index) in tags" :key="index"
                    @close="$refs.tagsRefCc.removeTag(index, $event)"
                    :type="!tag.archive ? 'is-primary' : 'is-warning'"
                    closable>
                    {{getNameTag(tag)}}
                  </b-tag>
                </template>
              </qd-taginput>
              <p class="label column is-2 pdb-0 mgt-5px">{{ $t('mail.cci') }}</p>
              <qd-taginput class="input-contact column is-10 pdb-0"
                          autocomplete
                          allow-new
                          :data="cciListContactTags"
                          group-field="nomCommercial"
                          group-options="contacts"
                          open-on-focus
                          field="nomToDisplay"
                          type="is-primary"
                          @typing="getFilteredCciListContact"
                          @input="getCciListContactTag"
                          expanded
                          ref="tagsRefCci"
                          v-model="cci">
                <template #selected="{ tags }">
                  <b-tag
                    v-for="(tag, index) in tags" :key="index"
                    @close="$refs.tagsRefCci.removeTag(index, $event)"
                    :type="!tag.archive ? 'is-primary' : 'is-warning'"
                    closable>
                    {{getNameTag(tag)}}
                  </b-tag>
                </template>
              </qd-taginput>
              <p class="label column is-2 pdb-0 mgt-5px">
                {{ $t('mail.objetMail') }}</p>
              <b-input
                type="text"
                v-model="mail.objet"
                expanded
                class="column is-10 pdb-0">
              </b-input>
              <p class="label column is-2 pdb-0 mgt-5px">
                {{ $t('mail.from') }}</p>
              <b-input
                type="text"
                v-model="mail.from"
                expanded
                class="column is-10 pdb-0">
              </b-input>
              <b-field :label="$t('mail.message')" class="column is-12">
                <qd-text-editor v-model="mail.corps"/>
              </b-field>
            </div>
            <div class="mgt-20px">
              <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close()">
                  {{ $t('mail.actions.cancel') }}
                </a>
              </div>
              <div class="is-pulled-left boutonAction">
                <a class="button is-primary" @click="emitInformation()">
                  {{ $t('mail.actions.send') }}
                </a>
              </div>
            </div>
          </div>
          <div class="column is-3">
            <div v-for="(editionAInclure, index) in editionsAInclure" :key="index"
                 class="mgb-10px">
              <b-field>
                <qd-switch v-model="editionAInclure.value"  type="is-primary">
                </qd-switch>
                <span> {{ $t(editionAInclure.libelle) }}</span>
              </b-field>
            </div>
            <div class="columns">
              <div class="column has-text-centered">
                <b-upload v-model="mail.piecesJointes"
                          multiple
                          drag-drop>
                  <div class="content">
                    <div class="mg-5px">
                      <b-icon icon="upload" type="is-primary" size="is-small"></b-icon>
                      <span>{{ $t('mail.actions.pj') }}</span>
                    </div>
                  </div>
                </b-upload>
              </div>
            </div>
            <div>
              <div class="card mgb-10px"
                   v-for="(pj, index) in mail.piecesJointes" :key="index">
                <div class="card-content level">
                  <div class="level-left">
                    <b-icon icon="file-document" type="is-default"></b-icon>
                    <span class="mgl-10px ellipsis width-100">{{ pj.name }}</span>
                  </div>
                  <div class="level-right is-cursor-pointer" @click="deletePieceJointe(pj)">
                    <b-icon icon="delete" type="is-danger"></b-icon>
                  </div>
                </div>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'popUpMail',
  props: {
    mail: {
      type: Object,
      required: true,
    },
    error: {
      type: Object,
      required: true,
    },
    editionsAInclure: {
      type: Array,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    contacts: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      to: [],
      toListContactTags: [],
      cc: [],
      ccListContactTags: [],
      cci: [],
      cciListContactTags: [],
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    fullContacts() {
      return [...this.contacts, {
        nomCommercial: this.$t('mail.collaborateur'),
        contacts: this.users.filter(c => c.email).map(c => {
          return {
            email: c.email,
            nomToDisplay: `${c.decorator.nomPrenom} - ${c.email}`,
            nom: c.nom,
            prenom: c.prenom,
          };
        }),
      }];
    },
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur).filter(u => u.actif);
    },
    isArchivedContactSelected() {
      const allContactsSelected = [...this.to, ...this.cc, ...this.cci];
      return allContactsSelected.some(contact => contact?.archive);
    },
  },
  methods: {
    deletePieceJointe(pj) {
      const index = this.mail.piecesJointes.indexOf(pj);
      this.mail.piecesJointes.splice(index, 1);
    },
    getNameTag(tag) {
      return tag.nomToDisplay ?? tag;
    },
    emitInformation() {
      this.mail.to = this.to.map((to) => {
        if (to.email) return to.email;
        return to;
      });
      this.mail.cc = this.cc.map((cc) => {
        if (cc.email) return cc.email;
        return cc;
      });
      this.mail.cci = this.cci.map((cci) => {
        if (cci.email) return cci.email;
        return cci;
      });
      this.$emit('sendEmail');
    },
    getCciListContactTag() {
      const list = [];
      this.fullContacts.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return !this.cci.find((cciContact) => { return cciContact.email === c.email; });
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.cciListContactTags = list;
    },
    getFilteredCciListContact(text) {
      this.getCciListContactTag();
      const list = [];
      this.cciListContactTags.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return c.nomToDisplay.toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.cciListContactTags = list;
    },
    getCcListContactTag() {
      const list = [];
      this.fullContacts.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return !this.cc.find((ccContact) => { return ccContact.email === c.email; });
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.ccListContactTags = list;
    },
    getFilteredCcListContact(text) {
      this.getCcListContactTag();
      const list = [];
      this.ccListContactTags.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return c.nomToDisplay.toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.ccListContactTags = list;
    },
    getToListContactTag() {
      const list = [];
      this.fullContacts.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return !this.to.find((toContact) => { return toContact.email === c.email; });
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.toListContactTags = list;
    },
    getFilteredToListContact(text) {
      this.getToListContactTag();
      const list = [];
      this.toListContactTags.forEach((contact) => {
        const filterContact = contact.contacts.filter((c) => {
          return c.nomToDisplay.toLowerCase().indexOf(text.toLowerCase()) >= 0;
        });
        if (filterContact.length > 0) {
          list.push({ nomCommercial: contact.nomCommercial, contacts: cloneDeep(filterContact) });
        }
      });
      this.toListContactTags = list;
    },
    initDataMail() {
      this.to = this.mail.to;
      this.cc = this.mail.cc;
      this.cci = this.mail.cci;
    },
  },
  mounted() {
    this.initDataMail();
    this.getToListContactTag();
    this.getCciListContactTag();
    this.getCcListContactTag();
  },
};
</script>
